import { useContext } from 'react';
import { Box, FormControl, Grid, InputLabel, MenuItem, Select, TextField, Typography, useMediaQuery } from '@mui/material';
import { ReportBuilderValues, ReportsBuilderContext } from '../context/ReportsBuilderContext';
import { theme } from '../../../theme';

const DataGroupSelector = () => {
  const {
    t,
    dataGroups,
    selectedDataGroup,
    handleDataGroupChange,
    loading,
    isEdit,
    reportName,
    handleReportChange,
    reportAggregationId,
    reportAggregations,
    handleAggregateChange,
  } = useContext(ReportsBuilderContext) as ReportBuilderValues;

  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  if (loading) {
    return null;
  }

  return (
    <Box
      sx={{
        border: '1px solid',
        borderRadius: '4px',
        borderColor: theme.palette.custom.gray[200],
        p: 3,
        mt: 3,
      }}
    >
      <Typography
        sx={{
          mb: 2,
          fontWeight: 'bold',
        }}
      >
        {t('reportConfiguration')}
      </Typography>
      
      <Grid container
        spacing={2}>
        <Grid item
          xs={isMobile ? 12 : 4}>
          <FormControl
            fullWidth
            size="small"
          >
            <InputLabel id="data-group-select-label">{t('dataGroup')} *</InputLabel>
            <Select
              labelId="data-group-select-label"
              id="data-group-select"
              size="small"
              value={selectedDataGroup || ''}
              label={t('dataGroup') + ' *'}
              onChange={(e) => handleDataGroupChange(Number(e.target.value))}
              disabled={isEdit} // Disable changing data group when editing existing report
            >
              {dataGroups
                ?.filter((dataGroup) => 
                  // Only show: Transactions (1), Credit Request (2), Theory/Actual (3), Stock on Hand (4)
                  // Hide: Items (5), Waste Percentage (6)
                  dataGroup.id && dataGroup.id <= 4,
                )
                .map((dataGroup) => (
                  <MenuItem
                    key={dataGroup.id}
                    value={dataGroup.id}
                  >
                    {dataGroup.name}
                  </MenuItem>
                ))}
            </Select>
          </FormControl>
        </Grid>
        
        <Grid item
          xs={isMobile ? 12 : 4}>
          <FormControl fullWidth
            size="small">
            <TextField
              id="outlined-basic"
              label={t('reportName')}
              size="small"
              variant="outlined"
              value={reportName}
              onChange={handleReportChange}
              required
            />
          </FormControl>
        </Grid>
        
        <Grid item
          xs={isMobile ? 12 : 4}>
          <FormControl fullWidth
            size="small">
            <TextField
              select
              id="aggregation-select"
              label={t('aggregation')}
              size="small"
              variant="outlined"
              value={reportAggregationId || ''}
              onChange={(e) => handleAggregateChange(Number(e.target.value))}
              required
            >
              {reportAggregations?.map((aggregation) => (
                <MenuItem
                  key={aggregation.id}
                  value={aggregation.id}
                >
                  {aggregation.name}
                </MenuItem>
              ))}
            </TextField>
          </FormControl>
        </Grid>
      </Grid>
    </Box>
  );
};

export default DataGroupSelector;
